import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { DriverAssignmentComponent } from "../driverassignment/driverassignment.component";
import { LocalSettingService } from "../local-setting/local-setting.service";
import { InvoicePrintService } from "../order/providers/invoiceprint.service";
import { DriverAssignementFormSettingFormComponent } from "./driverassignementsetting/driverassignementsetting-form.component";
import { DriverAssignementService } from "./driverassignment.service";
import { SimpleMenuComponent } from "./settingment";
import { DriverNotificationPipe } from "./driver-notification.pipe";
import { DescriptionAssignmentFormComponent } from "./DesceriptionAssignment/dynamic-input-form.component";

const components = [DriverAssignmentComponent, DriverAssignementFormSettingFormComponent, SimpleMenuComponent, DescriptionAssignmentFormComponent];
@NgModule({
  declarations: [...components, DriverNotificationPipe],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule, ReactiveFormsModule],
  providers: [DriverAssignementService, InvoicePrintService, LocalSettingService],
})
export class DriverAssignmentModule {
  constructor() {}
}
